import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { industries as fallbackIndustries, capabilities as fallbackCapabilities } from "../data";
import { getSiteContent } from "../cms/siteQueries";

export default function Industries() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    let mounted = true;
    getSiteContent()
      .then((data) => { if (mounted && data) setContent(data); })
      .catch((error) => console.error("Unable to load Industries content from Sanity:", error));
    return () => { mounted = false; };
  }, []);

  const industries = content?.industries || fallbackIndustries;
  const capabilities = content?.capabilities || fallbackCapabilities;

  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="relative bg-[#0a1929] text-white py-24 overflow-hidden">
        <div className="absolute inset-0 opacity-25 bg-cover bg-center" style={{ backgroundImage: `url(${capabilities[1].image})` }} />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a1929] via-[#0a1929]/90 to-[#0a1929]/30" />
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-[#ff6b7a] font-bold text-xs uppercase tracking-[0.3em] mb-4">Industries</div>
          <h1 className="font-black text-5xl lg:text-6xl leading-tight tracking-tight mb-5">Sectors We Power</h1>
          <p className="text-slate-300 max-w-2xl text-lg">
            Engineered solutions tailored for the demands of automotive, electronics, pharma and heavy manufacturing.
          </p>
        </div>
      </section>

      {industries.map((ind, i) => (
        <section key={ind.name} className={`py-24 ${i % 2 === 1 ? "bg-slate-50" : "bg-white"}`}>
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
            <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="aspect-[4/3] overflow-hidden">
                <img src={ind.image} alt={ind.name} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <div className="text-[#c8102e] font-bold text-xs uppercase tracking-[0.3em] mb-4">Sector 0{i + 1}</div>
              <h2 className="font-black text-4xl lg:text-5xl text-[#0a1929] tracking-tight leading-tight mb-6">{ind.name}</h2>
              <ul className="space-y-3 mb-8">
                {ind.services.map((s, si) => (
                  <li key={si} className="flex gap-3 text-slate-700">
                    <ChevronRight className="w-5 h-5 text-[#c8102e] mt-0.5 flex-shrink-0" /> {s}
                  </li>
                ))}
              </ul>
              <div className="bg-white border-l-4 border-[#c8102e] p-5 mb-8">
                <div className="text-[10px] uppercase tracking-widest text-slate-500 mb-1">Notable Clients</div>
                <div className="font-black text-[#0a1929] text-lg">{ind.clients}</div>
              </div>
              <Link to="/contact">
                <Button className="bg-[#0a1929] hover:bg-[#14213d] text-white rounded-none px-8 py-6 text-sm font-bold uppercase tracking-wide gap-2">
                  Discuss Your Project <ArrowRight className="w-4 h-4" />
                </Button>
              </Link>
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}
